import { CmsSectionShell } from './CmsSectionShell.tsx';
import { SectionHeading } from '../SectionHeading.tsx';
import { themeOf } from './cmsTheme.ts';
import { EnlargeableImage } from '../EnlargeableImage.tsx';
import type { MapSection } from '../../lib/types.ts';

/**
 * Generic editorial map section (CMS-031, S2): a per-section image plus an optional heading.
 * Content-free otherwise — the image is authored directly on the section (Media Library),
 * not sourced from festival data. Different pages/sections can show different maps (camping,
 * festival square, etc.). Omitted entirely when no image has been authored yet.
 *
 * The map keeps the aspect ratio it was uploaded in and is capped in height, so the section stays
 * a readable block on the page rather than a full-bleed banner. A map legend is unreadable at
 * that size by design — clicking opens it full-screen, where it can be zoomed and panned.
 */
export function CmsMapSection({ theme, guitar, heading, image }: MapSection) {
  if (!image) return null;

  const t = themeOf(theme);

  return (
    <CmsSectionShell theme={theme} guitar={guitar} width="5xl">
      {heading && <SectionHeading color={t.heading} eyebrowColor={t.eyebrow}>{heading}</SectionHeading>}
      <EnlargeableImage image={image} frame="natural" bgClass={t.img} sizes="(min-width: 1024px) 64rem, 100vw" />
    </CmsSectionShell>
  );
}
